module.exports = __webpack_public_path__ + "img/img4.8c6a8591.jpg";